import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'
import { UserAutoCompleter } from '../../UserAdmin/components/UserAutoCompleter'
import { PositionAutoCompleter } from '../../../components/PositionNew/components/PositionAutoCompleter'
import { DirectionFilter } from './DirectionFilter'

// Filtros del StockMovementKardexFilterDto. Se reutilizan las ramas ya
// existentes del FilterComponent (Marca, Almacén, Tipo de posición, Código de
// posición) y se agregan filtros custom para Dirección, Posición (por id) y
// Usuario.
export const filterOptions: FilterOption[] = [
  {
    key: 'movementDateRange',
    label: 'Rango de Fechas de Movimiento',
    type: 'daterange',
    order: 1
  },
  {
    key: 'sku',
    label: 'SKU',
    type: 'text',
    order: 2
  },
  {
    key: 'ean13',
    label: 'EAN13',
    type: 'text',
    order: 3
  },
  {
    key: 'workOrderId',
    label: 'OT',
    type: 'numeric',
    order: 4
  },
  {
    key: 'asnId',
    label: 'ID ASN',
    type: 'numeric',
    order: 5
  },
  {
    key: 'pickingRouteId',
    label: 'Ruta Picking',
    type: 'numeric',
    order: 6
  },
  {
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated',
    order: 7
  },
  {
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated',
    order: 8
  },
  {
    key: 'typeMovementeId',
    label: 'Dirección',
    type: 'custom',
    Component: DirectionFilter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer(),
    order: 9
  },


  {
    key: 'positionCode',
    label: 'Nombre Posición',
    type: 'custom',
    Component: PositionAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer(),
    order: 10
  },
  {
    key: 'typePositionId',
    label: 'Tipo de Posición',
    type: 'precreated',
    order: 11
  },
  {
    key: 'userId',
    label: 'Usuario',
    type: 'custom',
    Component: UserAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer(),
    order: 12
  },
  {
    key: 'batchNumber',
    label: 'Lote',
    type: 'text',
    order: 13
  },
  {
    key: 'expirationDateRange',
    label: 'Rango de Fechas de Expiración',
    type: 'daterange',
    canBeRepeated: false,
    order: 14
  }
]
